/* Mayflies theme — site behaviour (Shopify edition) */
(function () {
  const root = document.documentElement;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const routes = window.mfRoutes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartFetch: '/cart.js', root: '/' };
  const moneyFormat = (window.mfMoney && window.mfMoney.format) || '€{{amount_with_comma_separator}}';

  /* ── colour mode (light / dark / festival) ── */
  const cfg = window.mfTheme || { party: true, cycle: 6, modes: ['light', 'dark', 'party'] };
  const modes = cfg.party ? ['light', 'dark', 'party'] : ['light', 'dark'];
  const stored = (() => { try { return localStorage.getItem('mf-theme'); } catch (e) { return null; } })();
  let theme = stored || root.getAttribute('data-theme') || 'light';
  if (!modes.includes(theme)) theme = 'light';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sun = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="4.5"/><path d="M12 2v2.5M12 19.5V22M2 12h2.5M19.5 12H22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8"/></svg>';
  const moon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11z"/></svg>';
  const spark = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/><path d="M19 17l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7zM4.5 3.5l.5 1.5 1.5.5-1.5.5-.5 1.5-.5-1.5L2.5 5.5l1.5-.5z"/></svg>';
  const icons = { light: moon, dark: spark, party: sun };
  const names = { light: 'dark', dark: cfg.party ? 'festival' : 'light', party: 'light' };
  /* festival palette: one vivid hue for the page, a second for ink bands, text chosen for contrast */
  const partyVars = ['--color-bg', '--color-surface', '--color-surface-2', '--color-border', '--color-divider', '--color-text', '--color-text-muted', '--color-text-faint', '--color-text-inverse', '--color-primary', '--color-primary-hover', '--color-primary-fg', '--ink', '--ink-2', '--paper', '--foil'];
  const hsl = (h, sat, l) => `hsl(${((h % 360) + 360) % 360} ${sat}% ${l}%)`;
  const lum = (l) => l / 100;
  let partyTimer = null;
  const paintParty = () => {
    const h = Math.floor(Math.random() * 360);
    const light = Math.random() < 0.45;              // light or deep background
    const l = light ? 58 + Math.random() * 14 : 16 + Math.random() * 14;
    const sat = 70 + Math.random() * 25;
    const textDark = light && lum(l) > 0.5;
    const text = textDark ? hsl(h + 180, 35, 10) : hsl(h + 30, 30, 96);
    const accentH = h + (Math.random() < 0.5 ? 150 : 210);
    const set = (k, v) => root.style.setProperty(k, v);
    set('--color-bg', hsl(h, sat, l));
    set('--color-surface', hsl(h, sat, light ? l + 4 : l + 4));
    set('--color-surface-2', hsl(h, sat, light ? l - 5 : l + 8));
    set('--color-border', textDark ? hsl(h, 40, l - 22) : hsl(h, 40, l + 22));
    set('--color-divider', textDark ? hsl(h, 40, l - 14) : hsl(h, 40, l + 14));
    set('--color-text', text);
    set('--color-text-muted', textDark ? hsl(h + 180, 25, 28) : hsl(h + 30, 30, 84));
    set('--color-text-faint', textDark ? hsl(h + 180, 20, 42) : hsl(h + 30, 25, 70));
    set('--color-text-inverse', hsl(h, sat, l));
    set('--color-primary', hsl(accentH, 90, textDark ? 32 : 62));
    set('--color-primary-hover', hsl(accentH, 90, textDark ? 26 : 70));
    set('--color-primary-fg', hsl(accentH, 30, textDark ? 96 : 8));
    set('--ink', hsl(h + 120, 70, 14));
    set('--ink-2', hsl(h + 120, 70, 18));
    set('--paper', hsl(h + 120, 30, 96));
    set('--foil', hsl(accentH, 90, 62));
    root.toggleAttribute('data-party-light', textDark);
    /* independent random hues for the header pieces and the headings */
    const pop = (name) => set(name, hsl(Math.random() * 360, 85 + Math.random() * 15, textDark ? 28 + Math.random() * 14 : 58 + Math.random() * 18));
    pop('--party-menu'); pop('--party-cart'); pop('--party-toggle'); pop('--party-logo'); pop('--party-heading'); pop('--party-accent');
    set('--party-heading-bright', hsl(Math.random() * 360, 95, 68 + Math.random() * 12));
    tintLogos();
  };
  const tintLogos = () => $$('.header .logo, .footer .logo').forEach((logo) => {
    const img = $('img', logo);
    if (!img) return;
    let t = $('.logo__tint', logo);
    if (!t) { t = document.createElement('span'); t.className = 'logo__tint'; t.setAttribute('aria-hidden', 'true'); logo.appendChild(t); }
    const src = img.currentSrc || img.src;
    if (src) t.style.setProperty('--logo-mask', `url("${src}")`);
  });
  const untintLogos = () => $$('.logo__tint').forEach((t) => t.remove());
  const stopParty = () => { if (partyTimer) { clearInterval(partyTimer); partyTimer = null; } partyVars.forEach((k) => root.style.removeProperty(k)); ['--party-menu','--party-cart','--party-toggle','--party-logo','--party-heading','--party-accent','--party-heading-bright'].forEach((k) => root.style.removeProperty(k)); root.removeAttribute('data-party-light'); untintLogos(); };
  const startParty = () => { stopParty(); paintParty(); if (cfg.cycle > 0 && !reducedMotion) partyTimer = setInterval(paintParty, cfg.cycle * 1000); };
  const applyTheme = () => {
    root.setAttribute('data-theme', theme);
    if (theme === 'party') startParty(); else stopParty();
    $$('[data-theme-toggle]').forEach((b) => {
      b.innerHTML = icons[theme];
      b.classList.toggle('theme-btn--party', theme === 'party');
      b.setAttribute('aria-label', 'Switch to ' + names[theme] + ' mode');
      b.title = theme === 'party' ? 'Festival mode — click for light' : 'Switch to ' + names[theme] + ' mode';
    });
  };
  applyTheme();
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-theme-toggle]');
    if (!b) return;
    theme = modes[(modes.indexOf(theme) + 1) % modes.length];
    try { localStorage.setItem('mf-theme', theme); } catch (err) {}
    applyTheme();
  });
  document.addEventListener('visibilitychange', () => { if (theme === 'party') (document.hidden ? (partyTimer && clearInterval(partyTimer), partyTimer = null) : startParty()); });

  /* ── header scroll state ───────────────── */
  const initHeader = () => {
    const header = $('.header');
    if (!header) return;
    const onHero = header.classList.contains('header--onhero');
    const setHeader = () => {
      const y = window.scrollY;
      header.classList.toggle('header--scrolled', y > 40);
      if (onHero) header.classList.toggle('header--onhero', y <= 40);
    };
    setHeader();
    addEventListener('scroll', setHeader, { passive: true });
  };
  initHeader();

  /* ── overlay menu ──────────────────────── */
  let lastFocus = null;
  const menuEl = () => $('.menu');
  const openMenu = () => {
    const menu = menuEl(); if (!menu) return;
    lastFocus = document.activeElement;
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $$('[data-menu-open]').forEach((o) => o.setAttribute('aria-expanded', 'true'));
    setTimeout(() => $('.menu__link', menu)?.focus(), 350);
  };
  const closeMenu = () => {
    const menu = menuEl(); if (!menu) return;
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    $$('[data-menu-open]').forEach((o) => o.setAttribute('aria-expanded', 'false'));
    lastFocus?.focus();
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) openMenu();
    if (e.target.closest('[data-menu-close]')) closeMenu();
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && menuEl()?.getAttribute('aria-hidden') === 'false') closeMenu(); });
  const initMenuVisuals = () => {
    const menu = menuEl(); if (!menu) return;
    const visuals = $$('.menu__visual img', menu);
    const show = (key) => visuals.forEach((v) => v.classList.toggle('is-visible', v.dataset.key === key));
    $$('.menu__link', menu).forEach((l) => {
      l.addEventListener('mouseenter', () => show(l.dataset.visual));
      l.addEventListener('focus', () => show(l.dataset.visual));
    });
    const active = $('.menu__link.is-active', menu) || $('.menu__link', menu);
    if (active) show(active.dataset.visual);
  };
  initMenuVisuals();

  /* ── money ─────────────────────────────── */
  const fmt = (cents) => {
    const n = cents / 100;
    const m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    const kind = m ? m[1] : 'amount';
    let v;
    switch (kind) {
      case 'amount_no_decimals': v = Math.round(n).toLocaleString('en-US'); break;
      case 'amount_with_comma_separator': v = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_no_decimals_with_comma_separator': v = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
      case 'amount_with_apostrophe_separator': v = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"); break;
      default: v = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    v = v.replace(/[.,]00$/, '');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]+>/g, '');
  };

  /* ── toast ─────────────────────────────── */
  const toast = $('.toast');
  let toastT;
  const showToast = (msg) => {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toast.classList.remove('is-on'), 2600);
  };

  /* ── cart drawer (Shopify AJAX API) ────── */
  const drawer = $('[data-cart-drawer]');
  const backdrop = $('[data-cart-backdrop]');
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const emptyText = drawer?.dataset.emptyText || 'Go and fill it with something that lives for more than a day.';
  const emptyLink = drawer?.dataset.emptyLink || routes.shop || routes.root;
  const emptyLabel = drawer?.dataset.emptyLabel || 'Shop the book';
  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    const body = $('[data-cart-body]');
    const foot = $('[data-cart-foot]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = `<div class="drawer__empty"><h3>Your cart is <em>empty</em></h3><p>${esc(emptyText)}</p><a class="btn" href="${esc(emptyLink)}">${esc(emptyLabel)}</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items
      .map((i, idx) => {
        const line = idx + 1;
        const img = i.image ? `<img src="${esc(i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'))}" alt="" loading="lazy">` : '<div class="cart-item__noimg"></div>';
        const variant = i.product_has_only_default_variant ? '' : `<div class="variant">${esc(i.variant_title || '')}</div>`;
        return `<div class="cart-item" data-line="${line}" data-key="${esc(i.key)}">${img}
        <div><h4><a href="${esc(i.url)}">${esc(i.product_title)}</a></h4>${variant}
          <div class="qty"><button type="button" aria-label="Decrease quantity" data-cart-qty="${i.quantity - 1}" data-cart-line="${line}">−</button><span class="mono">${i.quantity}</span><button type="button" aria-label="Increase quantity" data-cart-qty="${i.quantity + 1}" data-cart-line="${line}">+</button></div></div>
        <div class="price">${fmt(i.final_line_price)}</div></div>`;
      })
      .join('');
    const sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = fmt(cart.total_price);
  };
  const fetchCart = () => fetch(routes.cartFetch, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const refreshCart = () => fetchCart().then(renderCart).catch(() => {});
  const openCart = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    backdrop?.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(); openCart(); }
    if (e.target.closest('[data-cart-close]')) closeCart();
  });
  backdrop?.addEventListener('click', closeCart);
  addEventListener('keydown', (e) => e.key === 'Escape' && closeCart());
  drawer?.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cart-qty]');
    if (!b) return;
    b.disabled = true;
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.dataset.cartLine, quantity: +b.dataset.cartQty }),
    })
      .then((r) => r.json())
      .then(renderCart)
      .catch(() => showToast('Could not update the cart'));
  });

  const addToCart = (formData, btn) => {
    const label = btn?.querySelector('[data-buy-label]') || btn;
    const orig = label?.textContent;
    if (btn) { btn.disabled = true; if (label) label.textContent = 'Adding…'; }
    formData.append('sections_url', location.pathname);
    return fetch(routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(async (r) => {
        const data = await r.json();
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        return refreshCart();
      })
      .then(() => { showToast('Added to cart'); setTimeout(openCart, 300); })
      .catch((err) => {
        const box = $('[data-form-error]');
        if (box) { box.textContent = err.message; box.hidden = false; }
        showToast(err.message);
      })
      .finally(() => { if (btn) { btn.disabled = false; if (label) label.textContent = orig; } });
  };

  // Intercept product forms (main product + quick add cards)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const isProduct = form.matches('#mf-product-form, form[data-quick-add]');
    if (!isProduct) return;
    e.preventDefault();
    const box = $('[data-form-error]');
    if (box) box.hidden = true;
    addToCart(new FormData(form), form.querySelector('[type="submit"]'));
  });

  /* ── product page: variants, qty, gallery ── */
  const initProduct = (section) => {
    const variantsEl = $('[data-variants]', section);
    const idInput = $('[data-variant-id]', section);
    const priceEl = $('[data-price]', section);
    const compareEl = $('[data-compare-price]', section);
    const buyBtn = $('[data-buy]', section);
    const buyLabel = $('[data-buy-label]', section);
    const addLabel = buyLabel?.textContent;
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const radios = $$('input[type="radio"][data-option-position]', section);
    const mainImg = $('.gallery__main img', section);
    const swapMain = (src, alt) => {
      if (!mainImg || !src) return;
      mainImg.style.opacity = 0;
      setTimeout(() => { mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.alt = alt || ''; mainImg.style.opacity = 1; }, 220);
    };
    const selected = () => {
      const opts = [];
      radios.forEach((r) => { if (r.checked) opts[+r.dataset.optionPosition - 1] = r.value; });
      return variants.find((v) => v.options.every((o, i) => o === opts[i]));
    };
    const paint = () => {
      radios.forEach((r) => r.closest('.pill')?.classList.toggle('is-selected', r.checked));
      if (!variants.length) return;
      const v = selected();
      if (!v) {
        if (buyBtn) { buyBtn.disabled = true; if (buyLabel) buyLabel.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (compareEl) { compareEl.hidden = !(v.compare_at_price > v.price); if (v.compare_at_price) compareEl.textContent = fmt(v.compare_at_price); }
      if (buyBtn) { buyBtn.disabled = !v.available; if (buyLabel) buyLabel.textContent = v.available ? addLabel : 'Sold out'; }
      if (v.featured_image) {
        const thumb = $(`.gallery__thumbs [data-media-id="${v.featured_media?.id || ''}"]`, section);
        if (thumb) thumb.click(); else swapMain(v.featured_image.src, v.featured_image.alt);
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    radios.forEach((r) => r.addEventListener('change', paint));
    paint();
    const qty = $('[data-qty]', section);
    $('[data-qty-inc]', section)?.addEventListener('click', () => { qty.value = Math.min(+qty.max || 99, (+qty.value || 1) + 1); });
    $('[data-qty-dec]', section)?.addEventListener('click', () => { qty.value = Math.max(1, (+qty.value || 1) - 1); });
    $$('.gallery__thumbs button', section).forEach((t) =>
      t.addEventListener('click', () => {
        $$('.gallery__thumbs button', section).forEach((x) => x.setAttribute('aria-selected', 'false'));
        t.setAttribute('aria-selected', 'true');
        swapMain(t.dataset.src, t.dataset.alt);
      })
    );
  };
  $$('[data-product-section]').forEach(initProduct);

  /* ── tour tabs ─────────────────────────── */
  const initTour = (tabs) => {
    const list = tabs.closest('section')?.querySelector('.tour');
    const empty = tabs.closest('section')?.querySelector('.tour-empty');
    if (!list) return;
    const apply = (mode) => {
      $$('button', tabs).forEach((b) => b.setAttribute('aria-selected', b.dataset.mode === mode));
      $$('li', list).forEach((li) => {
        const past = li.classList.contains('is-past');
        li.hidden = mode === 'upcoming' ? past : mode === 'past' ? !past : false;
      });
      empty?.toggleAttribute('hidden', !!$$('li:not([hidden])', list).length);
    };
    $$('button', tabs).forEach((b) => b.addEventListener('click', () => apply(b.dataset.mode)));
    apply(tabs.dataset.default || 'upcoming');
  };
  $$('.tour-tabs').forEach(initTour);

  /* ── hero slideshows ───────────────────── */
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initSlideshows = (scope = document) => {
    $$('[data-hero-slideshow]', scope).forEach((show) => {
      if (show.__mf) return;
      const slides = $$('[data-slide]', show);
      if (slides.length < 2) return;
      const dots = $$('.slides__dot', show.closest('.panel__media') || show.parentElement);
      const ms = Math.max(3, parseInt(show.dataset.interval || '6', 10)) * 1000;
      let i = 0, timer = null;
      const go = (n) => {
        slides[i].classList.remove('is-active'); dots[i]?.classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); dots[i]?.classList.add('is-active');
      };
      const start = () => { stop(); if (!reduced) timer = setInterval(() => go(i + 1), ms); };
      const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
      show.__mf = { start, stop, go };
      start();
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? start() : stop())), { threshold: 0.05 });
        io.observe(show.closest('.panel') || show);
      }
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    });
    $$('.panel__media video', scope).forEach((v) => { v.muted = true; v.play?.().catch(() => {}); });
  };
  initSlideshows();

  /* ── splash gallery: drift, drag, pin-fade ── */
  const initSplash = (scope = document) => $$('[data-splash]', scope).forEach((sp) => {
    if (sp.__mf) return;
    sp.__mf = true;
    const grid = $('[data-splash-grid]', sp);
    const rows = $$('[data-splash-row]', sp);
    const mask = $('[data-splash-mask]', sp);
    const word = $('[data-splash-word]', sp);
    if (!rows.length) return;
    const speed = reducedMotion ? 0 : (parseFloat(sp.dataset.speed) || 0);
    let offset = 0, vel = 0, dragging = false, lastX = 0, lastT = 0, hover = false, last = performance.now();
    const widths = () => rows.map((r) => ($('[data-splash-set]', r)?.getBoundingClientRect().width) || 1);
    let W = widths();
    const paint = () => rows.forEach((r, i) => { const w = W[i] || 1; const x = ((offset % w) + w) % w; r.style.transform = `translate3d(${-x}px,0,0)`; });
    const tick = (now) => {
      const dt = Math.min(0.05, (now - last) / 1000); last = now;
      if (!dragging) {
        if (Math.abs(vel) > 2) { offset += vel * dt; vel *= 0.94; }
        else if (!hover) offset += speed * dt;
      }
      paint();
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    window.addEventListener('resize', () => { W = widths(); });
    setTimeout(() => { W = widths(); }, 800);
    /* drag to scroll */
    grid.addEventListener('pointerdown', (e) => { dragging = true; vel = 0; lastX = e.clientX; lastT = performance.now(); grid.classList.add('is-dragging'); grid.setPointerCapture?.(e.pointerId); });
    grid.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      const now = performance.now(), dx = e.clientX - lastX, dt = Math.max(1, now - lastT);
      offset -= dx; vel = (-dx / dt) * 1000 * 0.6; lastX = e.clientX; lastT = now;
      if (Math.abs(dx) > 2) grid.dataset.moved = '1';
    });
    const end = () => { dragging = false; grid.classList.remove('is-dragging'); setTimeout(() => delete grid.dataset.moved, 50); };
    grid.addEventListener('pointerup', end); grid.addEventListener('pointercancel', end); grid.addEventListener('pointerleave', () => { if (dragging) end(); });
    grid.addEventListener('click', (e) => { if (grid.dataset.moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    grid.addEventListener('mouseenter', () => { hover = true; }); grid.addEventListener('mouseleave', () => { hover = false; });
    /* pin-fade as the next section slides over */
    const onScroll = () => {
      const rect = sp.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, -rect.top / (rect.height * 0.7)));
      if (mask) mask.style.opacity = (p * 0.92).toFixed(3);
      if (word) { word.style.opacity = (1 - p * 1.1).toFixed(3); word.style.transform = `translateY(${(-p * 60).toFixed(1)}px) scale(${(1 + p * 0.06).toFixed(3)})`; }
      rows.forEach((r, i) => { r.style.opacity = (1 - p * (1.1 + i * 0.15)).toFixed(3); });
    };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  });
  initSplash();

  /* ── splash tagline: fade up, hold, fade away ── */
  const initTaglines = (scope = document) => $$('[data-splash-tagline]', scope).forEach((tl) => {
    if (tl.__mf) return; tl.__mf = true;
    const lines = $$('.mf-splash__line', tl);
    if (lines.length < 2 || reducedMotion) return;
    const hold = Math.max(0.5, parseFloat(tl.dataset.hold) || 2.5) * 1000;
    const fade = Math.max(0.2, parseFloat(tl.dataset.fade) || 0.9) * 1000;
    const overlap = tl.dataset.overlap === 'true';
    let i = 0, timer = null;
    const step = () => {
      const prev = i; i = (i + 1) % lines.length;
      lines[prev].classList.remove('is-in'); lines[prev].classList.add('is-out');
      setTimeout(() => { lines[prev].classList.remove('is-out'); }, fade);
      setTimeout(() => { lines[i].classList.add('is-in'); }, overlap ? fade * 0.35 : fade * 0.9);
    };
    const start = () => { clearInterval(timer); timer = setInterval(step, hold + fade); };
    start();
    document.addEventListener('visibilitychange', () => { if (document.hidden) clearInterval(timer); else start(); });
  });
  initTaglines();

  /* ── community wall: media first, reviews on hover ── */
  const initWalls = (scope = document) => $$('[data-wall]', scope).forEach((wall) => {
    if (wall.__mf) return; wall.__mf = true;
    const media = $('[data-wall-media]', wall);
    const quotes = $('[data-wall-quotes]', wall);
    const mode = wall.dataset.revealMode || 'hover';
    const open = (on) => wall.classList.toggle('is-open', on);
    /* stagger the tiles in once the wall is on screen */
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { wall.classList.add('is-in'); io.disconnect(); } }), { threshold: 0.08 });
    io.observe(wall);
    /* play videos only while visible */
    const vids = $$('video', wall);
    if (vids.length) {
      const vio = new IntersectionObserver((es) => es.forEach((e) => { const v = e.target; if (e.isIntersecting) { v.play?.().catch(() => {}); } else v.pause?.(); }), { rootMargin: '200px 0px' });
      vids.forEach((v) => { v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; vio.observe(v); });
    }
    if (mode === 'hover') {
      wall.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') open(true); });
      wall.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') open(false); });
    }
    /* tap (touch) or click (click mode) on the wall shows the reviews */
    media.addEventListener('click', () => { open(true); wall.classList.add('is-touched'); });
    $$('[data-wall-open]', wall).forEach((b) => b.addEventListener('click', () => { open(true); wall.classList.add('is-touched'); }));
    $$('[data-wall-close]', wall).forEach((b) => b.addEventListener('click', () => open(false)));
    /* keyboard: focusing into the wall shows the reviews */
    wall.addEventListener('focusin', () => open(true));
    wall.addEventListener('focusout', (e) => { if (!wall.contains(e.relatedTarget)) open(false); });
    /* editor: when a review block is selected, show the reviews */
    document.addEventListener('shopify:block:select', (e) => { if (wall.contains(e.target)) open(!!e.target.closest('[data-wall-quotes]')); });
  });
  initWalls();

  /* ── manifesto: word-by-word reveal ───────── */
  const initWords = (scope = document) => $$('[data-words]', scope).forEach((el) => {
    if (el.dataset.done) return; el.dataset.done = '1';
    if (reducedMotion) return;
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3 && n.textContent.trim()) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) frag.appendChild(document.createTextNode(part));
            else { const w = document.createElement('span'); w.className = 'w'; w.textContent = part; frag.appendChild(w); }
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
    const words = $$('.w', el);
    const show = () => words.forEach((w, i) => setTimeout(() => w.classList.add('on'), 40 * i));
    const wio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { show(); wio.disconnect(); } }), { threshold: 0.25 });
    wio.observe(el);
    setTimeout(() => { if (el.getBoundingClientRect().top < innerHeight) { show(); wio.disconnect(); } }, 300);
  });
  initWords();

  /* ── reveal on scroll ──────────────────── */
  const io = new IntersectionObserver(
    (entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); } }),
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  const observeReveals = (scope = document) => $$('.reveal, .bleed', scope).forEach((el) => io.observe(el));
  observeReveals();

  /* ── decorative mayflies ───────────────── */
  const scatter = (scope = document) => $$('.mayflies-bg', scope).forEach((bg) => {
    if (bg.dataset.done) return;
    bg.dataset.done = '1';
    const n = +bg.dataset.count || 7;
    const svg = $('#mayfly-tpl')?.innerHTML || '';
    for (let i = 0; i < n; i++) {
      const el = document.createElement('div');
      el.className = 'mayfly';
      el.style.left = Math.random() * 92 + 2 + '%';
      el.style.top = Math.random() * 84 + 6 + '%';
      el.style.setProperty('--dur', 14 + Math.random() * 14 + 's');
      el.style.animationDelay = -Math.random() * 20 + 's';
      el.style.width = 22 + Math.random() * 22 + 'px';
      el.style.opacity = 0.08 + Math.random() * 0.14;
      el.innerHTML = svg;
      bg.appendChild(el);
    }
  });
  scatter();

  /* ── Theme Editor hooks ────────────────── */
  document.addEventListener('shopify:section:load', (e) => {
    initSlideshows(e.target); initSplash(e.target); initWords(e.target); initTaglines(e.target); initWalls(e.target); if (theme === 'party') tintLogos();
    const s = e.target;
    $$('.reveal, .bleed', s).forEach((el) => el.classList.add('is-inview'));
    scatter(s);
    $$('[data-product-section]', s).forEach(initProduct);
    $$('.tour-tabs', s).forEach(initTour);
    if (s.querySelector('.header')) { initHeader(); initMenuVisuals(); }
  });
  document.addEventListener('shopify:block:select', (e) => {
    const el = e.target;
    el.closest('.reveal')?.classList.add('is-inview');
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  if (window.Shopify && window.Shopify.designMode) {
    $$('.reveal, .bleed').forEach((el) => el.classList.add('is-inview'));
  }
})();
